import { StateAttributes } from '@zooplus/checkout-state/dist/es/types';

import { logError } from '@services/sentry-service';
import { PLACE_ORDER_URL } from '@utilities/constants';

export const placeOrder = (placeOrderPayload: Record<string, string>) => {
  if (!placeOrderPayload || Object.keys(placeOrderPayload).length === 0) {
    logError('placeOrder called with empty payload');
    return;
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = PLACE_ORDER_URL;
  form.setAttribute('data-testid', 'dynamic-place-order-form');

  Object.entries(placeOrderPayload).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};

export const getPlaceOrderData = (stateAttributes?: StateAttributes) => {
  return {
    customerHash: stateAttributes?.customerHash ?? '',
    orderPreviewGrandTotal: stateAttributes?.orderPreviewGrandTotal ?? '',
    'X-CSRF-Token': stateAttributes?.csrfToken ?? '',
  };
};
